import {toast as toastifyToast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Flex} from "antd";
import Icon from "@ant-design/icons";
import SuccessIcon from "@/assets/icons/successCircle.svg?react";
import WarningIcon from "@/assets/icons/warningTriangle.svg?react";
import InfoIcon from "@/assets/icons/InfoCircle.svg?react";
import ErrorIcon from "@/assets/icons/errorCircle.svg?react";
import i18n from "@/i18n/i18n.ts";

interface ToastContentProps {
    type: string;
    message: string;
}

const ToastContent = ({type, message}: ToastContentProps) => {

    let icon = <Icon component={InfoIcon} style={{fontSize: 24}}/>;
    if (type === 'success') {
        icon = <Icon component={SuccessIcon} style={{fontSize: 24}}/>;
    } else if (type === 'warning') {
        icon = <Icon component={WarningIcon} style={{fontSize: 24}}/>;
    } else if (type === 'error') {
        icon = <Icon component={ErrorIcon} style={{fontSize: 24}}/>;
    }

    return (
        <Flex align={'start'}>
            <div style={{marginRight: '10px'}}>
                {icon}
            </div>
            <div className={'mt-[2px]'}>
                <strong className={"text-size-4 text-white font-bold"}>{i18n.t(`title.${type}`)}</strong>
                <div className={"!mt-1 text-size-4 text-white"}>{message}</div>
            </div>
        </Flex>
    )
};

const showToast = (type: 'success' | 'error' | 'info' | 'warning', content: string) => {
    toastifyToast[type](<ToastContent type={type} message={content}/>, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: false,
        theme: "colored",
    });
};

// Export functions to show different types of toast messages
export const toast = {
    success: (content: string) => showToast('success', content),
    error: (content: string) => showToast('error', content),
    info: (content: string) => showToast('info', content),
    warning: (content: string) => showToast('warning', content),
};